import React from 'react';

const InviteOnlyPage = () => {
  const features = [
    { icon: "🤖", title: "AI Copilot", desc: "Chat with AI to create Python notebook cells" },
    { icon: "🐛", title: "AI Error Fixing", desc: "Automatic traceback analysis and fixes" },
    { icon: "🐍", title: "Python Notebooks", desc: "Run cells and build data pipelines" },
    { icon: "📂", title: "Import & Export", desc: "Upload CSV/XLSX, export results" },
    { icon: "📦", title: "Pip Packages", desc: "Install any PyPI package instantly" },
    { icon: "🔗", title: "Share Notebooks", desc: "Make notebooks public with a link" },
  ];

  const cases = [
    {
      emoji: "🔍",
      title: "Fraud Detection System",
      desc: "Handling extreme class imbalance with SMOTE",
      url: "https://scifi.ink/shared/53/fraud-detection-system"
    },
    {
      emoji: "📉",
      title: "Customer Churn Prediction",
      desc: "Feature engineering & ROI analysis",
      url: "https://scifi.ink/shared/54/customer-churn-prediction"
    },
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@300;400;500;600&family=Syne:wght@600;700;800&display=swap');
        .card-hover { transition: border-color 0.22s, box-shadow 0.22s, transform 0.22s; }
        .card-hover:hover { border-color: rgba(0,102,255,0.2) !important; box-shadow: 0 4px 24px rgba(0,102,255,0.06); transform: translateY(-2px); }
      `}</style>
      
      <div style={{
        minHeight: '100vh',
        background: '#f7f8fa',
        fontFamily: "'IBM Plex Mono', monospace",
        padding: '40px 20px'
      }}>
        {/* Hero Section */}
        <div style={{
          maxWidth: '680px',
          margin: '0 auto 60px',
          padding: '3rem',
          background: '#ffffff',
          borderRadius: '12px',
          border: '1.5px solid rgba(0,0,0,0.08)',
          boxShadow: '0 4px 32px rgba(0,0,0,0.07)',
          textAlign: 'center',
          position: 'relative'
        }}>
          <div style={{ marginBottom: '2rem', display: 'flex', justifyContent: 'center' }}>
            <img src={`${process.env.PUBLIC_URL}/logo/scifi_logo_transprent.png`} alt="sciFi Logo" style={{ height: 56, width: 'auto' }} />
          </div>

          <p style={{ fontSize: 14, color: '#8a9099', marginBottom: '2.5rem', letterSpacing: '0.05em' }}>
            AI CoPilot for Data Science
          </p>

          <div style={{
            padding: '2.5rem 2rem',
            background: 'rgba(0,102,255,0.04)',
            border: '1px solid rgba(0,102,255,0.12)',
            borderRadius: '8px',
            marginBottom: '2rem'
          }}>
            <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              border: '1px solid rgba(0,102,255,0.2)',
              borderRadius: 3,
              padding: '6px 16px',
              marginBottom: 20,
              background: 'rgba(0,102,255,0.06)'
            }}>
              <span style={{ fontSize: 10, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#0066ff' }}>Invite Only</span>
            </div>

            <h2 style={{
              fontFamily: "'Syne', sans-serif",
              fontSize: '28px',
              fontWeight: 700,
              color: '#0f1117',
              marginBottom: '1rem',
              letterSpacing: '-0.01em'
            }}>
              We're Enhancing the Platform
            </h2>
            
            <p style={{ fontSize: 14, color: '#3d4451', lineHeight: '1.8', marginBottom: '0' }}>
              New signups are temporarily paused while we improve sciFi.<br />
              Reach out to request early access.
            </p>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '2rem' }}>
            <a href="mailto:lucky@scifi.ink" style={{
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px',
              padding: '14px 24px', background: '#0f1117', color: 'white', textDecoration: 'none',
              borderRadius: '6px', fontSize: '14px', fontWeight: 500, transition: 'opacity 0.2s, box-shadow 0.2s'
            }}
              onMouseOver={(e) => { e.currentTarget.style.opacity = '0.88'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.15)'; }}
              onMouseOut={(e) => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.boxShadow = 'none'; }}
            >
              <span>📧</span><span>Email Us</span>
            </a>
            
            <div style={{ display: 'flex', gap: '12px' }}>
              <a href="https://wa.me/917769940498" target="_blank" rel="noopener noreferrer" style={{
                flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px',
                padding: '14px 24px', background: '#25D366', color: 'white', textDecoration: 'none',
                borderRadius: '6px', fontSize: '14px', fontWeight: 500, transition: 'opacity 0.2s, box-shadow 0.2s'
              }}
                onMouseOver={(e) => { e.currentTarget.style.opacity = '0.88'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(37,211,102,0.3)'; }}
                onMouseOut={(e) => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.boxShadow = 'none'; }}
              >
                <span>💬</span><span>WhatsApp</span>
              </a>

              <a href="tel:+917769940498" style={{
                flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px',
                padding: '14px 24px', background: '#0066ff', color: 'white', textDecoration: 'none',
                borderRadius: '6px', fontSize: '14px', fontWeight: 500, transition: 'opacity 0.2s, box-shadow 0.2s'
              }}
                onMouseOver={(e) => { e.currentTarget.style.opacity = '0.88'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,102,255,0.3)'; }}
                onMouseOut={(e) => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.boxShadow = 'none'; }}
              >
                <span>📞</span><span>Call</span>
              </a>
            </div>
          </div>

          <p style={{ fontSize: '11px', color: '#adb5bd', margin: 0 }}>
            Thank you for your interest in sciFi
          </p>
        </div>

        {/* Features Grid */}
        <div style={{ maxWidth: '1100px', margin: '0 auto 60px' }}>
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, marginBottom: 20 }}>
              <div style={{ width: 16, height: 1.5, background: '#0066ff', borderRadius: 1 }} />
              <span style={{ fontSize: 11, letterSpacing: '0.22em', textTransform: 'uppercase', color: '#0066ff' }}>Platform Features</span>
            </div>
            <h2 style={{
              fontFamily: "'Syne', sans-serif",
              fontSize: 'clamp(28px,4vw,40px)',
              fontWeight: 800,
              color: '#0f1117',
              letterSpacing: '-0.02em',
              marginBottom: 10
            }}>
              What sciFi Does
            </h2>
            <p style={{ fontSize: 14, color: '#8a9099' }}>Everything below is live in beta</p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(240px,1fr))',
            border: '1px solid rgba(0,0,0,0.08)',
            borderRadius: 8,
            overflow: 'hidden',
            background: '#ffffff'
          }}>
            {features.map((f, i) => (
              <div key={i} className="card-hover" style={{
                padding: '30px 26px',
                borderRight: '1px solid rgba(0,0,0,0.08)',
                borderBottom: '1px solid rgba(0,0,0,0.08)',
                background: '#ffffff'
              }}>
                <div style={{ fontSize: 22, marginBottom: 14 }}>{f.icon}</div>
                <h3 style={{
                  fontFamily: "'Syne', sans-serif",
                  fontSize: 15,
                  fontWeight: 700,
                  color: '#0f1117',
                  marginBottom: 9
                }}>{f.title}</h3>
                <p style={{ fontSize: 13, lineHeight: 1.85, color: '#8a9099' }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Hackathon Highlight */}
        <div style={{ maxWidth: '1100px', margin: '0 auto 60px' }}>
          <div style={{
            padding: '40px 36px',
            background: 'linear-gradient(135deg, rgba(0,102,255,0.08), rgba(138,43,226,0.08))',
            border: '1.5px solid rgba(0,102,255,0.15)',
            borderRadius: 12,
            textAlign: 'center'
          }}>
            <span style={{ fontSize: 32, display: 'block', marginBottom: 16 }}>🏥</span>
            <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              border: '1px solid rgba(0,102,255,0.2)',
              borderRadius: 3,
              padding: '6px 16px',
              marginBottom: 16,
              background: 'rgba(0,102,255,0.06)'
            }}>
              <span style={{ fontSize: 11, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#0066ff' }}>Our First Hackathon</span>
            </div>
            <h2 style={{
              fontFamily: "'Syne', sans-serif",
              fontSize: 'clamp(24px,4vw,34px)',
              fontWeight: 800,
              color: '#0f1117',
              letterSpacing: '-0.02em',
              marginBottom: 14
            }}>
              Vital Signs Anomaly Detection Sprint
            </h2>
            <p style={{ fontSize: 14, color: '#3d4451', marginBottom: 20, fontWeight: 500 }}>
              April 3-6, 2026 • Healthcare AI Hackathon
            </p>
            <p style={{ fontSize: 14, color: '#3d4451', lineHeight: 1.7, marginBottom: 28, maxWidth: 680, margin: '0 auto 28px' }}>
              Our inaugural hackathon brought together data scientists to build AI models for detecting anomalies in patient vital signs.
            </p>
            
            {/* Stats */}
            <div style={{ display: 'flex', gap: 32, justifyContent: 'center', flexWrap: 'wrap', marginBottom: 24 }}>
              <div>
                <div style={{ fontFamily: "'Syne', sans-serif", fontSize: 32, fontWeight: 800, color: '#0066ff', marginBottom: 4 }}>700+</div>
                <div style={{ fontSize: 13, color: '#8a9099' }}>Notebook Submissions</div>
              </div>
              <div>
                <div style={{ fontFamily: "'Syne', sans-serif", fontSize: 32, fontWeight: 800, color: '#0066ff', marginBottom: 4 }}>200+</div>
                <div style={{ fontSize: 13, color: '#8a9099' }}>Participants</div>
              </div>
            </div>

            <div style={{ display: 'flex', gap: 20, justifyContent: 'center', flexWrap: 'wrap', fontSize: 13, color: '#3d4451' }}>
              <div><span style={{ color: '#0066ff' }}>✓</span> Real healthcare data</div>
              <div><span style={{ color: '#0066ff' }}>✓</span> Cash prizes</div>
              <div><span style={{ color: '#0066ff' }}>✓</span> Free GPU access</div>
            </div>
          </div>
        </div>

        {/* Partners */}
        <div style={{ maxWidth: '1100px', margin: '0 auto 60px' }}>
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, marginBottom: 20 }}>
              <div style={{ width: 16, height: 1.5, background: '#0066ff', borderRadius: 1 }} />
              <span style={{ fontSize: 11, letterSpacing: '0.22em', textTransform: 'uppercase', color: '#0066ff' }}>Backed By</span>
            </div>
            <h2 style={{
              fontFamily: "'Syne', sans-serif",
              fontSize: 'clamp(28px,4vw,40px)',
              fontWeight: 800,
              color: '#0f1117',
              letterSpacing: '-0.02em',
              marginBottom: 10
            }}>
              Our Partners
            </h2>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 40 }}>
            <a href="https://www.nvidia.com/en-us/startups/" target="_blank" rel="noopener noreferrer" style={{
              opacity: 0.75,
              transition: 'opacity 0.3s, transform 0.3s',
              display: 'block'
            }}
              onMouseEnter={e => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.transform = 'scale(1.05)'; }}
              onMouseLeave={e => { e.currentTarget.style.opacity = '0.75'; e.currentTarget.style.transform = 'scale(1)'; }}
            >
              <img src={`${process.env.PUBLIC_URL}/logo/nvidia-inception.png`} alt="NVIDIA Inception Program" style={{ height: 140, width: 'auto', maxWidth: 260, objectFit: 'contain' }} />
            </a>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 50, flexWrap: 'wrap' }}>
              <a href="https://cloud.google.com/startup" target="_blank" rel="noopener noreferrer" style={{
                opacity: 0.7,
                transition: 'opacity 0.3s, transform 0.3s',
                display: 'block'
              }}
                onMouseEnter={e => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.transform = 'scale(1.05)'; }}
                onMouseLeave={e => { e.currentTarget.style.opacity = '0.7'; e.currentTarget.style.transform = 'scale(1)'; }}
              >
                <img src={`${process.env.PUBLIC_URL}/logo/google-cloud-startups.png`} alt="Google Cloud Partner" style={{ height: 110, width: 'auto', maxWidth: 200, objectFit: 'contain' }} />
              </a>
              <a href="https://www.wadhwanifoundation.org" target="_blank" rel="noopener noreferrer" style={{
                opacity: 0.7,
                transition: 'opacity 0.3s, transform 0.3s',
                display: 'block'
              }}
                onMouseEnter={e => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.transform = 'scale(1.05)'; }}
                onMouseLeave={e => { e.currentTarget.style.opacity = '0.7'; e.currentTarget.style.transform = 'scale(1)'; }}
              >
                <img src={`${process.env.PUBLIC_URL}/logo/wadhwani-foundation.png`} alt="Wadhwani Foundation" style={{ height: 110, width: 'auto', maxWidth: 200, objectFit: 'contain' }} />
              </a>
            </div>
          </div>
        </div>

        {/* Case Studies - Hidden */}
        {false && (
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, marginBottom: 20 }}>
              <div style={{ width: 16, height: 1.5, background: '#0066ff', borderRadius: 1 }} />
              <span style={{ fontSize: 10, letterSpacing: '0.22em', textTransform: 'uppercase', color: '#0066ff' }}>Real Examples</span>
            </div>
            <h2 style={{
              fontFamily: "'Syne', sans-serif",
              fontSize: 'clamp(26px,4vw,38px)',
              fontWeight: 800,
              color: '#0f1117',
              letterSpacing: '-0.02em',
              marginBottom: 10
            }}>
              See sciFi in Action
            </h2>
            <p style={{ fontSize: 13, color: '#8a9099' }}>Open these live notebooks — no sign-up needed</p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px,1fr))',
            gap: 16
          }}>
            {cases.map((c, i) => (
              <div key={i} className="card-hover" style={{
                padding: '36px 32px',
                background: '#ffffff',
                border: '1px solid rgba(0,0,0,0.08)',
                borderRadius: 8
              }}>
                <span style={{ fontSize: 28, display: 'block', marginBottom: 16 }}>{c.emoji}</span>
                <h3 style={{
                  fontFamily: "'Syne', sans-serif",
                  fontSize: 18,
                  fontWeight: 700,
                  color: '#0f1117',
                  marginBottom: 12
                }}>{c.title}</h3>
                <p style={{ fontSize: 12, color: '#8a9099', lineHeight: 1.7, marginBottom: 24 }}>{c.desc}</p>
                <button type="button" style={{
                  fontSize: 11,
                  letterSpacing: '0.12em',
                  textTransform: 'uppercase',
                  color: '#0066ff',
                  borderBottom: '1px solid rgba(0,102,255,0.18)',
                  paddingBottom: 2,
                  background: 'transparent',
                  border: 'none',
                  borderBottom: '1px solid rgba(0,102,255,0.18)',
                  cursor: 'pointer',
                  transition: 'border-color 0.2s'
                }}
                  onClick={() => window.open(c.url, "_blank")}
                  onMouseEnter={e => e.currentTarget.style.borderColor = '#0066ff'}
                  onMouseLeave={e => e.currentTarget.style.borderColor = 'rgba(0,102,255,0.18)'}
                >Open Notebook →</button>
              </div>
            ))}
          </div>
        </div>
        )}
      </div>
    </>
  );
};

export default InviteOnlyPage;
